/**
 * OmyBoat Product Page — product-page.js
 * Gallery image swap, smooth scrolling, cancellation modal, and UI interactions
 */

// ── Modal conditions d'annulation ──
function omyCancelModal(open) {
  var overlay = document.getElementById('cancel-modal');
  if (!overlay) return;
  if (open) {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    overlay.addEventListener('click', function onOverlayClick(e) {
      if (e.target === overlay) {
        omyCancelModal(false);
        overlay.removeEventListener('click', onOverlayClick);
      }
    });
    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') {
        omyCancelModal(false);
        document.removeEventListener('keydown', onEsc);
      }
    });
  } else {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

// Gallery Image Swap
function setGalleryImage(thumb) {
  var mainImg = document.getElementById('gallery-main-img');
  if (mainImg && thumb.dataset.src) {
    mainImg.src = thumb.dataset.src;
    document.querySelectorAll('.gallery-thumb').forEach(function(t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
  }
}

// Smooth scroll to reservation section
document.addEventListener('DOMContentLoaded', function() {
  var reserveButtons = document.querySelectorAll('a[href="#reservation"]');
  reserveButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById('reservation');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});

// ── Bandeau infos haute/basse saison ──
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var cfg = document.getElementById('season-guard-config');
    if (!cfg) return;

    var hsStart = cfg.dataset.hsStart;
    var hsEnd   = cfg.dataset.hsEnd;
    if (!hsStart || !hsEnd) return;

    // Ancrage STABLE : #product-form (statique, jamais retire par BTA), avec repli sur
    // #season-guard-config. On ne depend plus du widget BTA, que l'init xcomponent retire/
    // reinjecte pendant le chargement -> l'encart disparaissait par intermittence (race
    // condition, cf. cross-project-tests/season-banner-storefront.test.ts).
    if (document.querySelector('.omy-season-banner')) return; // idempotent

    var isEN = document.documentElement.lang.startsWith('en');

    var monthsFR = ['janvier','f\xe9vrier','mars','avril','mai','juin','juillet','ao\xfbt','septembre','octobre','novembre','d\xe9cembre'];
    var monthsEN = ['January','February','March','April','May','June','July','August','September','October','November','December'];

    function fmtDate(iso, lang) {
      var p = iso.slice(0, 10).split('-');
      var m = parseInt(p[1], 10) - 1;
      var d = parseInt(p[2], 10);
      if (lang === 'en') return (monthsEN[m] || '') + ' ' + d;
      var suf = d === 1 ? 'er' : '';
      return d + suf + ' ' + (monthsFR[m] || '');
    }

    function addDays(iso, n) {
      var dt = new Date(iso + 'T00:00:00Z');
      dt.setUTCDate(dt.getUTCDate() + n);
      return dt.toISOString().slice(0, 10);
    }

    var bsStart = addDays(hsEnd, 1);
    var bsEnd   = addDays(hsStart, -1);

    var lang = isEN ? 'en' : 'fr';
    var hsStartFmt = fmtDate(hsStart, lang);
    var hsEndFmt   = fmtDate(hsEnd,   lang);
    var bsStartFmt = fmtDate(bsStart, lang);
    var bsEndFmt   = fmtDate(bsEnd,   lang);

    var intro = isEN
      ? 'Please select whether you wish to book in high or low season using the calendar below. Here are the season dates for this boat :'
      : 'Veuillez s\xe9lectionner si vous souhaitez louer en haute ou en basse saison dans le calendrier ci-dessous. Pour vous aider, voici les informations des saisons de ce bateau :';

    var dash = ' – ';

    // Basse saison : si la haute saison est contenue dans l'annee (cas normal, ex. ete),
    // la basse saison est a cheval sur le Nouvel An -> on l'affiche en DEUX plages
    // ("1er janvier ... et ... 31 decembre") plutot qu'une seule plage qui traverse l'annee.
    function md(iso) { return iso.slice(5, 10); }
    var andSep = isEN ? ' and ' : ' et ';
    var lowText;
    if (md(hsStart) <= md(hsEnd)) {
      var parts = [];
      if (md(hsStart) !== '01-01') parts.push(fmtDate('2000-01-01', lang) + dash + bsEndFmt);
      if (md(hsEnd)   !== '12-31') parts.push(bsStartFmt + dash + fmtDate('2000-12-31', lang));
      lowText = parts.join(andSep) || (bsStartFmt + dash + bsEndFmt);
    } else {
      // Haute saison a cheval sur l'annee -> basse saison contigue, une seule plage.
      lowText = bsStartFmt + dash + bsEndFmt;
    }

    var banner = document.createElement('div');
    banner.className = 'omy-season-banner';
    banner.innerHTML =
      '<p class="omy-season-intro">' + intro + '</p>' +
      '<div class="omy-season-pills">' +
        '<span class="omy-season-pill omy-season-high">' +
          (isEN ? '🌞 High season : ' : '🌞 Haute saison : ') +
          '<strong>' + hsStartFmt + dash + hsEndFmt + '</strong>' +
        '</span>' +
        '<span class="omy-season-pill omy-season-low">' +
          (isEN ? '🌊 Low season : ' : '🌊 Basse saison : ') +
          '<strong>' + lowText + '</strong>' +
        '</span>' +
      '</div>';

    var form = document.getElementById('product-form');
    var insertRef = (form && form.parentNode) ? form : cfg;
    if (insertRef && insertRef.parentNode) insertRef.parentNode.insertBefore(banner, insertRef);
  });
})();
